import { setTerm } from './helpers';

export const setWheelchairAccessible = setTerm('wheelchair_accessible');
